import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const flagsActivitiesReducer = combineReducers({
  list,
  view,
});

export default flagsActivitiesReducer;
